
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/topBar/dashboardShortcut/dashboardShortcut.scss.css.virtualfile';
        module.exports = {"dashboard-shortcut-wrapper":"_dashboard-shortcut-wrapper_1mr2v_1","dashboardShortcutWrapper":"_dashboard-shortcut-wrapper_1mr2v_1"};